import { withConfirmationDialog } from "@components/dialog/withConfirmationDialog";
import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { IPrPaternityLeaveEventEntity, PrPaternityLeaveEventEntity } from "@odata/GeneratedEntityTypes";
import { PrSocialEventTypeCode } from "@odata/GeneratedEnums";
import {
    handleDateEventEndDefaultingOnChange,
    handleEntitlementChange
} from "@pages/payroll/socialEvents/SocialEvents.utils";
import { SocialEventsFormViewForExtend } from "@pages/payroll/socialEvents/SocialEventsFormView";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";

class PaternityLeaveFormView extends SocialEventsFormViewForExtend<IPrPaternityLeaveEventEntity> {
    typeCode = PrSocialEventTypeCode.PaternityLeave;

    handleChange = (e: ISmartFieldChange): void => {
        const { storage } = this.props;
        const { bindingContext } = e;

        // before change to have access to orig value
        handleDateEventEndDefaultingOnChange(storage, e, 2);

        const path = bindingContext.getPath();
        if (path === PrPaternityLeaveEventEntity.PaternityLeaveEntitlement) {
            storage.clearValueByPath(PrPaternityLeaveEventEntity.IsChildHospitalized);
        }

        super.handleChange(e);

        // after super, because we need to have updated data in storage for handleEntitlementChange
        handleEntitlementChange(this.props.storage, e);
    }
}

export default withPermissionContext(withConfirmationDialog(PaternityLeaveFormView));
